module.exports = "/static/assets/a2e09fa89bbe4b6d9f3364168c3caa94.png";